import { render, staticRenderFns } from "./clienteHistorico.vue?vue&type=template&id=c9f854be"
import script from "./clienteHistorico.vue?vue&type=script&lang=js"
export * from "./clienteHistorico.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports